import { AccountType } from '@context/AvContext.types';

export enum HistoricalMode {
  Intuitive = 'INTUITIVE',
  Complex = 'COMPLEX',
}

export type DatastoreMappingItem = {
  id?: string;
  accountId?: string;
  datastoreCategory?: string;
  datastoreId?: string;
  serviceName?: string;
  datastoreConfig?: Record<string, any>;
};

export type PocExtensionConfig = {
  allowedExtensionDays: number[];
  defaultExpirationDays: number;
};

export type TGateway = {
  id?: string;
  name: string;
  proxyDnsName: string;
  publicKey: string;
  privateDnsName?: string;
};

export type CustomerDto = {
  id: string;
  mainAccount: {
    id: string;
    name: string;
    accountType: AccountType;
    customerFacing?: boolean;
    rcSubDomain?: string;
  };
  provider: string;
  domains?: string[];
  crmId: string;
  disableWelcomeEmail: boolean;
  zendeskId?: string;
  saml?: string;
  lakehouseAccountId?: string;
  idleTimeout?: number;
  subAccounts: {
    id: string;
    name: string;
    accountType: AccountType;
    customerFacing?: boolean;
    rcSubDomain?: string;
  }[];
  childCustomers?: {
    id: string;
    mainAccount: {
      id: string;
      name: string;
      accountType: AccountType;
    };
    crmId: string;
  }[];
};

export type ZscalerAccountConfigObject = {
  zscmAccountId?: string;
  ziaTenantsConfigs?: ZiaTenantsConfig[];
  zpaTenantsConfigs?: ZpaTenantsConfig[];
};

export type ZiaTenantsConfig = {
  cloudName: string;
  companyId: string;
};

export type ZpaTenantsConfig = {
  cloudName: string;
  tenantId: string;
};
export const cronExpressionTypes = {
  Daily: '0 0 * * *',
  Hourly: '0 * * * *',
  // Weekly: '0 0 * * 0',
  // Monthly: '0 0 1 * *',
} as const;

export type CronExpression = (typeof cronExpressionTypes)[keyof typeof cronExpressionTypes];

export type AuditLogsExportConfig = {
  enabled: boolean;
  includedEntities: string[];
  integrationId: string | undefined;
  cronExpression: CronExpression;
};

export type AiFeaturesDto = {
  enabled: boolean;
};
